import { render, staticRenderFns } from "./Events2.vue?vue&type=template&id=a2d65aa0&scoped=true&"
import script from "./Events2.vue?vue&type=script&lang=js&"
export * from "./Events2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d65aa0",
  null
  
)

export default component.exports